import React, { memo } from "react";
import { TIMELINE_RANGE_SELECTOR_MODE } from "../constants";
import TimelineRangeSelector from "../timelineRangeSelector";
import styles from "./timeline.module.css";
import classNames from "classnames";
function Timeline(props) {
    return (React.createElement("div", { className: classNames(styles.container, "unselectable") },
        React.createElement(TimelineRangeSelector, { mode: TIMELINE_RANGE_SELECTOR_MODE.TIMELINE, maxTicksCount: props.maxTicksCount, data: props.data, interval: props.interval, onSetInterval: props.onSetInterval })));
}
export default memo(Timeline);
Timeline.defaultProps = {
    maxTicksCount: 60
};
